import * as constants from "../../constants";

const initialState = {
  selected_csa: {
    csa: {},
    csa_user: {},
    csa_members: [],
    csa_members_total: 0,
    csa_pending_enrollments: [],
    new_enrollment_id: "",
  },
  csas: [],
  total: 0,
};

export default function csa(state = initialState, action) {
  switch (action.type) {
    case constants.CSA_RECEIVE_CSA:
      return {
        ...state,
        selected_csa: {
          ...state.selected_csa,
          csa: action.payload.csa,
        },
      }
    case constants.CSA_RECEIVE_USER:
      return {
        ...state,
        selected_csa: {
          ...state.selected_csa,
          csa_user: action.payload.user,
        },
      }
    case constants.CSA_RECEIVE_MEMBERS:
      return {
        ...state,
        selected_csa: {
          ...state.selected_csa,
          csa_members: action.payload.members,
          csa_members_total: action.payload.total,
        },
      }
    case constants.CSA_RECEIVE_NEW_ENROLLMENT_ID:
      return {
        ...state,
        selected_csa: {
          ...state.selected_csa,
          new_enrollment_id: action.payload.enrollmentID,
        },
      }

    case constants.CSA_RECEIVE_PENDING_ENROLLMENTS:
      return {
        ...state,
        selected_csa: {
          ...state.selected_csa,
          csa_pending_enrollments: action.payload.enrollments,
        },
      }
    case constants.CSA_LIST_CSA:
      return {
        ...state,
        csas: action.payload.csas,
        total: action.payload.total,
      }
    default:
      return state;
  }
}
